export type Roll = {
  rollNumber: string
  lengthValue: number
  lengthUnit: number
  weight: number
  dateKnitted: string | undefined
  rollState: number
  bay?: string
  lastEditedBy: string
  batchId: string
  isActive?: boolean
  knittingQualityId: string
  finishingQualityId: string
}

export enum RollState {
  Greig = 0,
  Offsite = 1,
  Finished = 2,
  Available = 3,
  Dispatched = 4
}
